<div [class]="linkType" class="sso-handler-container">
  @switch (ssoType) {
    @case ('agentCubed') {
      <app-agent-cubed-sso class="sso-link" [agentCubedLabel]="ssoLabel" [lob]="lob"></app-agent-cubed-sso>
    }
    @case ('broker360') {
      <app-broker360-sso class="sso-link" [broker360Label]="ssoLabel"></app-broker360-sso>
    }
    @case ('marcom') {
      <app-marcom-sso class="sso-link" [marcomLabel]="ssoLabel"></app-marcom-sso>
    }
    @case ('heeter') {
      <app-heeter-sso class="sso-link" [heeterLabel]="ssoLabel"></app-heeter-sso>
    }
    @case ('salesForce') {
      <app-sales-force-sso class="sso-link" [label]="ssoLabel" [lob]="lob"></app-sales-force-sso>
    }
    @case ('salesForceTest') {
      <app-sales-force-test-sso class="sso-link" [label]="ssoLabel" [lob]="lob"></app-sales-force-test-sso>
    }
    @case ('salesForceUAT') {
      <app-sales-force-uat-sso class="sso-link" [label]="ssoLabel" [lob]="lob"></app-sales-force-uat-sso>
    }
    @case ('connectureEnroll') {
      <app-connecture-enroll-sso class="sso-link" [label]="ssoLabel" [lob]="lob"></app-connecture-enroll-sso>
    }
    @case ('cavulus') {
      <app-cavulus-sso class="sso-link" [label]="ssoLabel"></app-cavulus-sso>
    }
    @case ('apm') {
      <app-apm-sso class="sso-link" [apmLabel]="ssoLabel"></app-apm-sso>
    }
    @case ('healthSherpa') {
      <app-health-sherpa-sso class="sso-link" [healthSherpaLabel]="ssoLabel"></app-health-sherpa-sso>
    }
    @case ('benefitsManager') {
      <app-benefits-manager-sso class="sso-link" [healthSherpaLabel]="ssoLabel"></app-benefits-manager-sso>
    }
    @case ('curtisDirect') {
      <app-curtis-direct-sso class="sso-link" [label]="ssoLabel"></app-curtis-direct-sso>
    }
    @case ('ebill') {
      <app-ebill-sso class="sso-link" [prospectId]="arguments?.prospectId" [label]="ssoLabel"></app-ebill-sso>
    }
    <!-- Plan Advisor SSO -->
    @case ('planAdvisorRenewal') {
      <app-plan-advisor-sso class="sso-link" [planAdvisorLabel]="ssoLabel" [isRenewal]="true"
        [customData]="customData">
      </app-plan-advisor-sso>
    }
    @case ('planAdvisorNewToBlue') {
      <app-plan-advisor-sso class="sso-link" [planAdvisorLabel]="ssoLabel" [isRenewal]="false"
        [customData]="customData">
      </app-plan-advisor-sso>
    }
    <!-- Plan Advisor V2 SSO -->
    @case ('planAdvisorV2NewToBlue') {
      <app-plan-advisor-v2-sso class="sso-link" [planAdvisorLabel]="ssoLabel" [isRenewal]="false"
        [customData]="customData">
      </app-plan-advisor-v2-sso>
    }
    @case ('planAdvisorV2Renewal') {
      <app-plan-advisor-v2-sso class="sso-link" [planAdvisorLabel]="ssoLabel" [isRenewal]="true"
        [customData]="customData">
      </app-plan-advisor-v2-sso>
    }
  }
</div>